<div class="clip-details-container">
	<div class="d-flex justify-content-end align-items-center">
		<!-- <span class="title" mat-dialog-title>{{ data.mode === 'PENDING' ? ('ASSORTED.PENDING' | translate) : ('BUTTON.' + data.mode | translate) }}</span> -->
		<button mat-icon-button (click)="closeDialog()" class="clip-details-close d-flex justify-content-center align-items-center m-1">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 mx-2 px-4">
		@if (clipDetails) {
		<div class="row">
			<div class="col">
				<div class="d-flex justify-content-between flex-wrap mb-3">
					<span>{{ 'CONTRACT_NOTICES.PUBLISHED_DATE' | translate }}: {{ utils.formatDate(clipDetails.publicationDate) }}</span>

					<div class="medium d-flex ms-auto me-3">
						<mat-icon class="font small me-1">{{ utils.getIconByType('MEDIUM_' + clipDetails.medium?.type) }}</mat-icon>
						<span class="font medium">{{ utils.getParameterByLanguageScript(clipDetails.medium, 'name') }}</span>
					</div>

					<div class="w-100">
						@if(clipDetails.authors?.length) {
						<span class="font medium me-3">{{ 'CLIPS.AUTHOR' | translate }}: {{ getAuthors(clipDetails) }}</span>
						}
            @if(clipDetails.medium?.type === "PRINTED" && clipDetails.pageNumber) {
						<span class="font medium me-3">{{ 'CLIPS.PAGE_NUMBER' | translate }}: {{ clipDetails.pageNumber }}</span>
						} @if(clipDetails.medium?.type === "PRINTED" && clipDetails.area) {
						<span class="font medium me-3">{{ 'CLIPS.AREA' | translate }}: {{ clipDetails.area }}</span>
						} @if(clipDetails.medium?.type === "PRINTED" && clipDetails.sif) {
						<span class="font medium me-3">{{ 'CLIPS.SIF' | translate }}: {{ clipDetails.sif }}</span>
						}
					</div>
				</div>
				<div class="mb-3">
					<span class="title">{{ utils.getParameterByLanguageScript(clipDetails, 'title', true) }}</span>
					@if (clipDetails.competitorOnly) {
					<span class="competitor-badge" [title]="'CLIPS.COMPETITOR_TOOLTIP' | translate">{{ 'CLIPS.COMPETITOR_BADGE' | translate }}</span>
					}
				</div>

				<p>{{ utils.getParameterByLanguageScript(clipDetails, 'text', true) }}</p>
			</div>

			<div class="col-lg-6 col-md-12">
				<div class="d-flex justify-content-center align-items-start w-100">
					@if(clipDetails.medium?.type === 'TV') {
					<div class="clip-video-wrapper">
						<video
							#videoPlayer
							controls
							controlsList="nodownload"
							[poster]="externalAssets + '/images/' + 'player_poster.png'"
							autoplay
							(loadedmetadata)="onVideoLoadedMetadata()"
							(timeupdate)="onVideoTimeUpdate()"
							(seeked)="onVideoSeeked()">
							<source [src]="clipDetails.mediaUrl" type="video/mp4" />
							Your browser does not support the video tag.
						</video>

						@if (videoDuration > 0) {
						<div class="clip-boundary-bar">
							<div class="clip-boundary-labels">
								<input
									type="text"
									class="clip-boundary-time-input"
									[value]="formatTime(boundaryStart)"
									(change)="onBoundaryStartTimeChange($event)" />
								<input
									type="text"
									class="clip-boundary-time-input"
									[value]="formatTime(boundaryEnd)"
									(change)="onBoundaryEndTimeChange($event)" />
							</div>
							<div class="clip-boundary-slider-row" (wheel)="onBoundaryBarWheel($event)">
								<mat-slider [min]="sliderMin" [max]="sliderMax" [step]="1" class="clip-boundary-slider">
									<input matSliderStartThumb [(ngModel)]="boundaryStart" (change)="reArmAutoStop()" />
									<input matSliderEndThumb [(ngModel)]="boundaryEnd" (change)="reArmAutoStop()" />
								</mat-slider>
								<div class="clip-boundary-zoom-controls">
									<button mat-icon-button type="button" (click)="zoomOut()" [disabled]="zoomLevel <= minZoom">
										<mat-icon>zoom_out</mat-icon>
									</button>
									<button mat-icon-button type="button" (click)="zoomIn()" [disabled]="zoomLevel >= maxAllowedZoom">
										<mat-icon>zoom_in</mat-icon>
									</button>
								</div>
							</div>
							<button mat-stroked-button color="primary" class="clip-boundary-reset" (click)="resetBoundaries()">
								<mat-icon>restart_alt</mat-icon>
								{{ 'CLIPS.RESET_BOUNDARIES' | translate }}
							</button>
						</div>
						}
					</div>
					} @else if (clipDetails.medium?.type === 'RADIO') {
					<audio controls autoplay>
						<source [src]="clipDetails.mediaUrl" type="audio/mpeg" />
						Your browser does not support the audio element.
					</audio>
					} @else if (clipDetails.medium?.type === 'PRINTED') {
					<img class="newspaper-cutout" [src]="clipDetails.mediaUrl" alt="newspaper-cutout" />
					}
				</div>
			</div>
		</div>
		}
	</mat-dialog-content>

	<mat-dialog-actions [align]="'start'">
		<mat-divider class="w-100 my-2"></mat-divider>
		@if (clipDetails.medium?.type === 'TV') {
		<!-- TV: the download button gives the video clip between the current start/end markers. -->
		<button mat-flat-button class="clip-details-pdf-btn" (click)="downloadVideoClip()" [disabled]="apiLoading">
			@if(apiLoading) {
			<mat-spinner diameter="20"></mat-spinner>
			} @else {
			<mat-icon class="m-0">download</mat-icon>
			}
		</button>
		} @else {
		<!-- Every other medium keeps the PDF report as before. -->
		<button mat-flat-button class="clip-details-pdf-btn" (click)="generatePdfReport()" [disabled]="apiLoading">
			@if(apiLoading) {
			<mat-spinner diameter="20"></mat-spinner>
			} @else {
			<mat-icon class="m-0">download</mat-icon>
			}
		</button>
		}
		<!-- <button mat-flat-button color="primary" (click)="closeDialog()">
			{{ 'BUTTON.CLOSE' | translate }}
		</button> -->
	</mat-dialog-actions>
</div>
